'use strict';

angular.module('schoolbushubApp').controller('SchoolDialogController',
    ['$scope', '$stateParams', '$uibModalInstance', 'entity', 'School', 'Organization',
        function($scope, $stateParams, $uibModalInstance, entity, School, Organization) {

        $scope.school = entity;
        $scope.organizations = Organization.resource.query();
        $scope.load = function(id) {
            School.get({id : id}, function(result) {
                $scope.school = result;
            });
        };

        var onSaveSuccess = function (result) {
            $scope.$emit('schoolbushubApp:schoolUpdate', result);
            $uibModalInstance.close(result);
            $scope.isSaving = false;
        };

        var onSaveError = function (result) {
            $scope.isSaving = false;
        };

        $scope.save = function () {
            $scope.isSaving = true;
            if ($scope.school.id != null) {
                School.update($scope.school, onSaveSuccess, onSaveError);
            } else {
                School.save($scope.school, onSaveSuccess, onSaveError);
            }
        };

        $scope.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
}]);
